module.exports = __webpack_public_path__ + "static/media/placeholderQuizz.82b97b65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StickyPhone/medias/placeholderQuizz.jpg
// module id = 197
// module chunks = 0